// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 930) return "static/chunks/930-ad984e9e9608c20bc280.js";
	if (chunkId === 8436) return "static/chunks/8436-e64ec1b15e81221b192b.js";
	if (chunkId === 1818) return "static/chunks/1818-1e10b55820e21c8c7ae3.js";
	if (chunkId === 6737) return "static/chunks/6737-4a96d4b7d60ee9d2ff64.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2554 ? "effa34c9" : chunkId) + "." + {"1662":"38867b508eb808ee04c1","2478":"70dda9de6719ebd8b760","2554":"4b77f3361e8ac59de857","4211":"2d77bcf9a36b2ce99aa3","4362":"2e3323419068edb040ed","8795":"6bf86a4f1e09a4299a2f"}[chunkId] + ".js";
};